<template>
    <div>
        <section class="section">
            <div class="container">
                <h1 class="title has-text-centered">
                    <b-button size=""
                              type="is-danger"
                              icon-left="file-alt"
                              @click.prevent="deleteAllProject()">
                        Saisir un nouveau project
                    </b-button>
                    {{ ProjectName }}
                </h1>
                <h2 class="subtitle has-text-centered">
                    <b>{{ ProjectNameReadable }} </b>
                    <br>
                    <em>{{ ProjectPhase ? ProjectPhase : 'Sélectionner une phase' }}</em>
                </h2>

                <b-field grouped>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Nom du projet</b-tag>
                            <b-tag type="is-info"> {{ ProjectName }}</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Frais de personnel</b-tag>
                            <b-tag type="is-info"> {{ ProjectSalarieCost }} €</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Frais de missions</b-tag>
                            <b-tag type="is-info"> {{ ProjectFraisCost }} €</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Achat de matériel</b-tag>
                            <b-tag type="is-info"> {{ ProjectMaterielCost }} €</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Sous-traitance</b-tag>
                            <b-tag type="is-info"> {{ ProjectSSTCost }} €</b-tag>
                        </b-taglist>
                    </div>
                    <!-- Frais généraux -->
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Frais généraux {{ ProjectType ? `(${ProjectType})` : null }}</b-tag>
                            <b-tag type="is-primary"> {{ projectFraisGeneraux }} €</b-tag>
                        </b-taglist>
                    </div>
                </b-field>
                <b-field grouped>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Coût total sans frais généraux</b-tag>
                            <b-tag type="is-warning"> {{ updateProjectCostSansFG }} €</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Coût total</b-tag>
                            <b-tag type="is-warning"> {{ updateProjectCostSansFG + projectFraisGeneraux}} €</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Prise en charge financeurs</b-tag>
                            <b-tag type="is-success"> {{ ProjectFICost }} €</b-tag>
                        </b-taglist>
                    </div>
                    <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Marge indicative</b-tag>
                            <b-tag type="is-danger"> {{ ProjectSalariesMarge }} €</b-tag>
                        </b-taglist>
                    </div>
                </b-field>

                <b-steps
                    v-model="activeStep"
                    animated
                    rounded
                    has-navigation
                    size="is-medium">
                    <b-step-item step="1" label="Projet" clickable>
                        <!-- Nom du projet -->
                        <ProjectSaisie
                            @projectName="updateProjectName"
                            @ProjectNameReadable="updateProjectNameReadable"
                            @projectPhase="updateProjectPhase"
                            @projectDayCost="updateProjectDayCost"
                            @projectType="updateProjectType"
                            @project="updateFullProject"
                            :rev="rev"
                            @next="next">
                        </ProjectSaisie>
                    </b-step-item>

                    <b-step-item step="2" label="Frais de personnel" :clickable="nextstep">

                        <Salaries
                            @updateProjectSalariesCost="updateProjectSalariesCost"
                            @updateProjectSalariesMarge="updateProjectSalariesMarge"
                            @updateProjectDaysWithoutSupport="updateProjectDaysWithoutSupport"
                            :ProjectDayCost="ProjectDayCost"
                        >
                        </Salaries>

                    </b-step-item>

                    <b-step-item step="3" label="Frais de mission" :clickable="nextstep">
                        <FraisMission
                            @updateProjectFraisCost="updateProjectFraisCost">
                        </FraisMission>
                    </b-step-item>

                    <b-step-item step="4" label="Achat de matériel" :clickable="nextstep">
                        <Materiel
                            @updateProjectMaterielCost="updateProjectMaterielCost"
                            :ProjectType="ProjectType">
                        </Materiel>
                    </b-step-item>

                    <b-step-item step="5" label="Sous-traitance" :clickable="nextstep">
                        <SousTraitance
                            @updateProjectSSTCost="updateProjectSSTCost"
                            :ProjectType="ProjectType">
                        </SousTraitance>
                    </b-step-item>

                    <b-step-item step="6" label="Financeurs" :clickable="nextstep">
                        <Financeurs
                            :totalCostProjectSansFG="updateProjectCostSansFG"
                            :totalCostProject="updateProjectCostSansFG + projectFraisGeneraux"
                            :ProjectSalarieCost="ProjectSalarieCost"
                            :ctma="Project.ctma === undefined ? false : Project.ctma"
                            :fg="Project.type === 'Subvention' ? true : false"
                            @updateProjectFICost="updateProjectFICost">
                        </Financeurs>
                    </b-step-item>

                    <b-step-item step="7" label="Fiche de présentation" :clickable="nextstep">
                        <Finalisation>

                        </Finalisation>
                    </b-step-item>

                    <b-step-item step="8" label="Vérification" :clickable="nextstep">
                        <Verification
                            :rev="rev"
                            :synth="sendSynth">
                        </Verification>
                    </b-step-item>


                    <template
                        slot="navigation"
                        slot-scope="{previous, next}">
                        <b-button
                            type="is-primary"
                            icon-pack="fas"
                            icon-left="backward"
                            @click.prevent="previous.action">
                            Précédent
                        </b-button>
                        &nbsp;
                        <b-button
                            type="is-primary"
                            icon-pack="fas"
                            icon-right="forward"
                            @click.prevent="next.action"
                            v-if="activeStep !== 7"
                            :disabled="!nextstep">
                            Suivant
                        </b-button>
                        <hr>

                    </template>


                </b-steps>


            </div>
        </section>
    </div>
</template>

<script>
import ProjectSaisie from "./ProjectSaisie";
import Salaries from "./Salaries";
import SousTraitance from "./SousTraitance";
import FraisMission from "./FraisMission";
import Financeurs from "./Financeurs";
import Verification from "./Verification";
import Finalisation from "./Finalisation";
import Materiel from "./Materiel";

export default {
    name: 'HelloWorld',
    components: {
        Materiel,
        Finalisation,
        Verification,
        Financeurs,
        FraisMission,
        SousTraitance,
        Salaries,
        ProjectSaisie
    },
    mounted() {
        if (localStorage.getItem("_rev")) {
            this.rev = JSON.parse(localStorage.getItem("_rev"));
        }
    },
    computed: {
        sendSynth() {
            let synth = {};
            // Dont send calculate value
            // synth.ProjectSalarieCost = this.ProjectSalarieCost
            synth.ProjectFraisCost = this.ProjectFraisCost
            synth.ProjectMaterielCost = this.ProjectMaterielCost
            synth.ProjectSSTCost = this.ProjectSSTCost
            synth.ProjectFICost = this.ProjectFICost
            // Dont send calculate value
            // synth.ProjectCost = this.updateProjectCostSansFG
            // synth.ProjectFraisGeneraux = this.projectFraisGeneraux
            return synth
        },
        updateProjectCostSansFG() {
            return this.ProjectSalarieCost +
                this.ProjectFraisCost +
                this.ProjectMaterielCost +
                this.ProjectSSTCost
                // + this.projectFraisGeneraux; // Don't add fg to variable but add it on display only
        },
        projectFraisGeneraux() {
            // Si le projet est une subvention
            // Calcul CTMA
            if (this.Project.ctma === true) {
                /*
                Calcul Erwan :
                ( nb jour sans support * 12 000 ) / 210 - frais mission
                */
                return ( this.ProjectDaysWithoutSupport * 12000 ) / 210 - this.ProjectFraisCost
            } else if (this.ProjectType === 'Subvention') {
                // MAJ Calcul Natacha // TODO
                if (this.ProjectFI.length > 0) {
                    let ElodieFG = 0
                    this.ProjectFI.forEach(fi => {
                        if (fi.pclock) {
                            ElodieFG += this.ProjectSalarieCost * (fi.percent / 100) * (fi.tauxfg / 100)
                            console.log(this.ProjectSalarieCost * (fi.percent / 100) * (fi.tauxfg / 100))
                        } else {
                            let pc = fi.cost / (fi.tauxfg/100 * this.ProjectSalarieCost + this.updateProjectCostSansFG)
                            let fg = this.ProjectSalarieCost * pc * (fi.tauxfg/100)
                            console.log(fg)
                            ElodieFG += fg;
                        }
                    })
                    return ElodieFG
                } else {
                    return 0
                }
            } else if (this.ProjectType === 'Prestation') {
                return 0
            } else {
                return 0 // Charge uniquement & Subvention sans frais généraux
            }
        }
    },
    methods: {
        // Read full project properties
        updateFullProject(e) {
            this.Project = e;
        },
        updateProjectType(e) {
            this.ProjectType = e;
        },
        updateProjectName(e) {
            this.ProjectName = e;
        },
        updateProjectNameReadable(e) {
            this.ProjectNameReadable = e;
        },
        updateProjectPhase(e) {
            this.ProjectPhase = e;
        },
        updateProjectDayCost(e) {
            this.ProjectDayCost = e;
        },
        updateProjectSalariesCost(e) {
            this.ProjectSalarieCost = e;
        },
        updateProjectSalariesMarge(e) {
            this.ProjectSalariesMarge = e;
        },
        updateProjectDaysWithoutSupport(e) {
            this.ProjectDaysWithoutSupport = e;
        },
        updateProjectFraisCost(e) {
            this.ProjectFraisCost = e;
        },
        updateProjectMaterielCost(e) {
            this.ProjectMaterielCost = e;
        },
        updateProjectSSTCost(e) {
            this.ProjectSSTCost = e;
        },
        updateProjectFICost(e, f) {
            this.ProjectFICost = e;
            // Retreive full fi to calculate fg
            this.ProjectFI = f;
        },
        deleteAllProject() {
            this.$buefy.dialog.confirm({
                title: `Nouvelle saisie`,
                confirmText: "Oui, je confirme",
                type: "is-danger",
                hasIcon: true,
                message: `Saisir un nouveau projet va effacer la saisie en cours, êtes-vous sûr ?`,
                onConfirm: () => {
                    localStorage.clear();
                    localStorage.setItem("dbSelected", process.env.VUE_APP_CURRENTDB);
                    window.location.reload();
                }
            });
        },
        next(n) {
            // console.log(n)
            this.nextstep = n
        },
    },
    data() {
        return {
            Project: {},
            ProjectDaysWithoutSupport: null,
            ProjectName: null,
            ProjectNameReadable: null,
            ProjectType: null,
            ProjectPhase: null,
            ProjectSalarieCost: 0,
            ProjectSalariesMarge: 0,
            ProjectFraisCost: 0,
            ProjectMaterielCost: 0,
            ProjectSSTCost: 0,
            ProjectFICost: 0,
            ProjectFI: [],
            ProjectDayCost: null,
            activeStep: 0,
            nextstep: false,
            rev: false,
        }
    }
}
</script>

